<template>
    <div class="operation-column">
        <el-button
            v-for="(btn, index) in inlineButtons"
            v-tooltip.top="{
                content: btn.tooltip || '',
                class: btn.tooltip ? '' : 'tooltip-hidden',
            }"
            :key="index"
            :icon="btn.icon"
            :type="btn.type || 'primary'"
            @click="btn.action(rowItem)"
        >{{ btn.text }}</el-button>
        <el-button
            v-tooltip.top="getVerbose('ns_paginate_table_column_edit_tooltip')"
            v-if="canEditModel"
            icon="ti ti-pencil"
            type="primary"
            @click="emitShowModalEditObject(rowItem)"
        ></el-button>
        <el-dropdown
            trigger="click"
            placement="bottom-start"
            class="dropdown-operation"
            @command="handleCommand"
            v-if="dropdownButtons.length > 0"
        >
            <span>
                <i class="el-icon-more" style="transform: rotate(90deg); font-size: 20px;"></i>
            </span>
            <el-dropdown-menu
                slot="dropdown"
            >
                <el-dropdown-item
                    v-for="(btn, index) in dropdownButtons"
                    :key="index"
                    :command="index"
                    :icon="btn.icon"
                >{{ btn.text }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {

    components: {

    },

    props: {
        operationsColumn: {
            type: Array,
            required: true,
        },
        rowItem: {
            type: Object,
            required: true,
        },
        canEditModel: {
            type: Boolean,
            required: true,
        },
    },

    data (){
        return {

        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ]),
        inlineButtons (){
            return this.operationsColumn.filter((ope) => ope.inline);
        },
        dropdownButtons (){
            return this.operationsColumn.filter((ope) => !ope.inline);
        },
    },

    mounted (){

    },

    methods: {
        handleCommand (command){
            this.dropdownButtons[command].action(this.rowItem);
        },
        emitShowModalEditObject(data) {
            this.$emit('emitShowModalEditObject', data);
        }
    },
};
</script>

<style lang="scss">
.tooltip-hidden{
    visibility: hidden;
}
.operation-column{
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .dropdown-operation{
        margin-left: 15px;
    }
    .el-button {
        border-color: #A7D2FF;
        background-color: #ECF5FE;
        color: #96CAFF;
        padding: 6px 15px;
        font-size: 20px;
        // color: #A7D2FF
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/operations-column.vue